import {Component, Input, OnInit} from '@angular/core';
import {FormBuilder, FormGroup, Validators} from '@angular/forms';
import {autocompleteEvkOption, EvkFormComponentBase, EvkOption} from '@evomatik/evk-common';
import {Observable} from 'rxjs';
import {EnAutorizacionDiligenciaFormService} from './service/en-autorizacion-diligencia-form.service';
import {filter, map, startWith} from 'rxjs/operators';
import {TareaDocumentoModel} from "../../../../../../../diligencia/models/tarea-documento.model";
import {DiligenciaTareaModel} from "../../../../../../../diligencia/models/diligencia-tarea.model";

@Component({
    selector: 'lib-en-autorizacion-diligencia-form',
    templateUrl: './en-autorizacion-diligencia-form.component.html',
    styleUrls: ['./en-autorizacion-diligencia-form.component.scss']
})
export class EnAutorizacionDiligenciaFormComponent extends EvkFormComponentBase<TareaDocumentoModel> implements OnInit {

    form: FormGroup;

    @Input()
    public diligencia: DiligenciaTareaModel;

    @Input()
    public configAutorizador: any;

    @Input()
    public origen: string;

    @Input()
    public generarFormato: boolean;

    @Input()
    public organizacionOrigen: any;

    tiposOrganizacionOptions: EvkOption[] = [];
    organizacionesOptions: EvkOption[] = [];
    usuariosOptions: EvkOption[] = [];

    organizacionesFilteredOptions$: Observable<EvkOption[]>;
    tiposOrganizacionFilteredOptions$: Observable<EvkOption[]>;
    usuariosFilteredOptions$: Observable<EvkOption[]>;

    constructor(
        public fb: FormBuilder,
        public autorizacionDiligenciaFormService: EnAutorizacionDiligenciaFormService,
    ) {
        super(fb);
    }

    protected get formBuild(): FormGroup {
        return this.fb.group({
            idNegocio: this.diligencia.id,
            tipoTarea: 'SOLICITUD',
            detalle: this.diligencia,
            generarFormato: this.generarFormato,
            tipoOrganizacion: [null, [Validators.required, autocompleteEvkOption]],
            organizacion: [null, [Validators.required, autocompleteEvkOption]],
            usuarioAsignado: [null, [autocompleteEvkOption]],
            activo: true,
        });
    }

    ngOnInit() {
        super.ngOnInit();
        this.cargarCatalogos();
        this.eventHandlerEventInit();
    }

    eventHandlerEventInit() {
        this.tiposOrganizacionFilteredOptions$ = this.form.controls.tipoOrganizacion.valueChanges
            .pipe(
                startWith(''),
                filter(value => typeof value === 'string'),
                map(name => name ? this._filter(name, this.tiposOrganizacionOptions) : this.tiposOrganizacionOptions.slice()),
            );

        this.organizacionesFilteredOptions$ = this.form.controls.organizacion.valueChanges
            .pipe(
                startWith(''),
                filter(value => typeof value === 'string'),
                map(name => name ? this._filter(name, this.organizacionesOptions) : this.organizacionesOptions.slice()),
            );

        this.usuariosFilteredOptions$ = this.form.controls.usuarioAsignado.valueChanges
            .pipe(
                startWith(''),
                filter(value => typeof value === 'string'),
                map(name => name ? this._filter(name, this.usuariosOptions) : this.usuariosOptions.slice()),
            );
    }

    public cargarCatalogos() {
        if (this.origen != null && this.origen === 'paginador') {
            this.autorizacionDiligenciaFormService.getDiligenciaConfigForNombre(this.diligencia.nombreDiligencia).subscribe(
                (response) => {
                    this.configAutorizador = response.tipoOrganizacionAutorizador;
                    this.cargaUnidadesAutorizar();
                }, (error) => {
                    console.log(error);
                }
            );
        } else {
            this.cargaUnidadesAutorizar();
        }
    }

    cargaUnidadesAutorizar() {
        this.autorizacionDiligenciaFormService.getDiligenciaFindNegocio(this.diligencia.id).subscribe(
            (res) => {
                const estatus = this.checkEstatusActivo(res.estadoTarea);
                if (estatus === 'CREADA' || estatus === 'EN CORRECCIÓN' || estatus === 'POR AUTORIZAR') {
                    this.tiposOrganizacionOptions = this.configAutorizador;
                    this.precargaTipoOrganizacion();
                } else if (estatus === 'EN AUTORIZACIÓN') {
                    this.cargarTiposOrganizaciones();
                    this.precargaTipoOrganizacion();
                } else {
                    alert('cargar otra configuracion');
                }
            }
        );
    }

    precargaTipoOrganizacion() {
        const tipoOrganizacion = {
            label: localStorage.getItem('tipoOrganizacion'),
            value: localStorage.getItem('tipoOrganizacionId')
        };
        const organizacion = {label: localStorage.getItem('unidad'), value: localStorage.getItem('unidadId')};
        if (this.tiposOrganizacionOptions.some(opt => opt.value === tipoOrganizacion.value)) {
            this.form.controls['tipoOrganizacion'].patchValue(tipoOrganizacion);
            this.cargaOrganizacionesByTipo(tipoOrganizacion);
            this.form.controls['organizacion'].patchValue(organizacion);
            this.cargarUsuarios(organizacion);
        }
    }

    checkEstatusActivo(estatusList) {
        let estatusActivo = '';
        estatusList.forEach(estatus => {
            if (estatus.activo) {
                estatusActivo = estatus.estado.nombre;
            }
        });
        return estatusActivo;
    }

    cargarTiposOrganizaciones() {
        this.resetOptionsUsuarioAsignado();
        if (this.organizacionOrigen['value'] !== null) {
            this.autorizacionDiligenciaFormService.getTiposOrganizacionesByOrganizacionOrigenAndTipoConfiguracion(this.organizacionOrigen['value'], 'AUTORIZACION').subscribe(usuarios => {
                this.tiposOrganizacionOptions = usuarios;
            });

        }
    }

    cargarUsuarios(organizacion) {
        this.resetOptionsUsuarioAsignado();
        if (organizacion.value !== null) {
            this.autorizacionDiligenciaFormService.getUsuariosForUnidadOrganizacional(organizacion.value, ['AUTORIZADOR']).subscribe(usuarios => {
                const usuariosFiltrados = usuarios.filter(usuario => usuario.label !== localStorage.getItem('nombreCompleto'));
                this.usuariosOptions = usuariosFiltrados;
            });
        }
    }

    cargaOrganizacionesByTipo(tipoOrganizacion: EvkOption) {
        this.resetOptionsOrganizaciones();
        if (tipoOrganizacion.value !== null) {
            this.autorizacionDiligenciaFormService.getOrganizacionesByTipoOrganizacion(tipoOrganizacion.value).subscribe(organizaciones => {
                this.organizacionesOptions = organizaciones;
            });
        }
    }

    cleanValuesTipoOrganizacion(event$: any) {
        if (event$.target.value === '') {
            this.resetOptionsOrganizaciones();
        }
    }

    cleanValuesOrganizaciones(event$: any) {
        if (event$.target.value === '') {
            this.resetOptionsUsuarioAsignado();
        }
    }

    resetOptionsOrganizaciones() {
        this.organizacionesOptions = [];
        this.usuariosOptions = [];
        this.resetValues(['organizacion', 'usuarioAsignado']);
    }

    resetOptionsUsuarioAsignado() {
        this.usuariosOptions = [];
        this.resetValues(['usuarioAsignado']);
    }

    resetValues(nameControls: string[]) {
        nameControls.forEach(value => {
            this.form.controls[value].setValue('');
        });
    }
}
